import { render, staticRenderFns } from "./zlgl.vue?vue&type=template&id=5f797ec3&scoped=true&"
import script from "./zlgl.vue?vue&type=script&lang=js&"
export * from "./zlgl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f797ec3",
  null
  
)

export default component.exports